import React, { Component } from 'react'
import debounce from 'lodash/debounce'

const withWindowSize = ChildComponent =>
  class extends Component {
    constructor(props) {
      super(props)
      this.state = this.calculateSize()
      this.recalculateDebounce = debounce(this.recalculate, 300)
    }
    componentDidMount() {
      window.addEventListener('resize', this.recalculateDebounce)
      window.addEventListener('orientationchange', this.recalculate)
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.recalculateDebounce)
      window.removeEventListener('orientationchange', this.recalculate)
    }
    recalculate = () => {
      this.setState(this.calculateSize())
    }
    calculateSize() {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
        orientation:
          window.innerWidth / window.innerHeight > 1 ? 'landscape' : 'portrait'
      }
    }
    render() {
      return <ChildComponent {...this.props} windowSize={this.state} />
    }
  }

export default withWindowSize
